import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    // Checkbox,
    Space,
    Tabs,
    Checkbox,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  // import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    RangePickerItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem
  } from "../../../../Components/Items";
  import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
  import * as XLSXStyle from "xlsx-js-style";
  import { ResponsiveLine } from "@nivo/line";
  import moment from "moment";
  import "moment/locale/es";
    import reporteDeOrdenesDeCompraPdf from "../../../../Pdf/reporteDeOrdenesDeCompraPdf";
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;

  // Formato Contabilidad de Excel: el $ pegado al borde izquierdo de la celda y
  // el numero pegado a la derecha. Es el estandar de los Excel de esta app.
  const FORMATO_CONTABILIDAD =
    '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';

  // El ancho calculado del encabezado se queda corto para el nombre completo de
  // un usuario y para varias requisiciones concatenadas.
  const ANCHOS_ESPECIALES = { Usuario: 26, Requisicion: 22 };
  
  class ReporteOrdenesDeCompras extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoProveedores: null,
      todasProveedores: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      dataReporte: null,
      todasCompras: [],
      dataGrafico: [],
      subtotal: 0,
      totalImpuestos: 0,
      total: 0,
      totalRetenciones: 0,
      totalAPagar: 0,
      desglosarProductos: false
    };
  
    atras() {
        this.props.history.goBack();
    }
  
    async componentDidMount() {
      this.setState({ loading: true });
      await axios
        .post(
          "proveedores/selectProveedores",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProveedores: res.data });
            this.setState({
              objetoProveedores: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "usuarios/selectUsuariosEmpresa",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUsuarios: res.data });
            this.setState({
              objetoUsuarios: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre +
                      " " +
                      value.apellidoPaterno +
                      " " +
                      value.apellidoMaterno}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      this.consultarReporteCompras({
        periodo: [moment().subtract(1, "month"), moment()],
        proveedores: 0,
        filtrarProyecto: 0,
        estadoFacturas: 5,
      });
    }
  
    async crearGrafico(valueCompras, fechaInicial, fechaFinal) {
      let grafico = [];
      let graficoSumatoria = [];
      let sumatoria = 0;
  
      let fechaCambiante = moment(fechaInicial).locale("es");
      const fechaFinalMoment = moment(fechaFinal).locale("es");
  
      if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
        while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "date"
              );
            } else {
              return false;
            }
          });
  
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
        while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "week"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("[SEM] WW/YY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("[SEM] WW/YY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
        while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "month"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("MM-YY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("MM-YY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
        }
      } else {
        while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "year"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("YYYY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("YYYY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
        }
      }
  
      await this.setState({
        dataGrafico: [
          {
            id: "Compras",
            color: "hsl(15, 70%, 50%)",
            data: grafico,
          },
          {
            id: "Compras Acumuladas",
            color: "hsl(15, 70%, 50%)",
            data: graficoSumatoria,
          },
        ],
      });
    }
  
    consultarReporteCompras(values) {
      this.setState({ loading: true });
      axios
        .post(
          "reportesDeCompras/reporteOrdenesDeCompras",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.crearGrafico(
              res.data.compras,
              res.data.fechaInicial,
              res.data.fechaFinal
            );
            this.setState({
              loading: false,
              dataReporte: res.data,
              todasCompras: res.data.compras,
              subtotal: res.data.subtotal,
              totalImpuestos: res.data.totalImpuestos,
              total: res.data.total,
              totalRetenciones: res.data.totalRetenciones,
              totalAPagar: res.data.totalAPagar,
              desglosarProductos: res.data.desglosarProductos,
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      const border = {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      };
      const headerStyle = {
        font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "00BFD6" } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        border,
      };
      const cellStyle = { alignment: { vertical: "center" }, border };
      const moneyStyle = {
        alignment: { horizontal: "right", vertical: "center" },
        numFmt: FORMATO_CONTABILIDAD,
        border,
      };
      const numberStyle = {
        alignment: { horizontal: "right", vertical: "center" },
        border,
      };
      const percentStyle = {
        alignment: { horizontal: "right", vertical: "center" },
        border,
      };

      // aoa_to_sheet usa el objeto {v, s} tal cual y NO infiere el tipo: sin
      // t: "n" el numero se escribe como texto y el numFmt nunca se aplica.
      // La celda vacia conserva el estilo para que, si alguien teclea encima,
      // ya salga con el formato de la columna.
      const celda = (value, tipo) => {
        if (tipo === "money") {
          return typeof value === "number"
            ? { v: value, t: "n", s: moneyStyle }
            : { v: "", s: moneyStyle };
        }
        if (tipo === "numero") {
          const numero = Number(value);
          return value !== null && value !== undefined && value !== "" && Number.isFinite(numero)
            ? { v: numero, t: "n", s: numberStyle }
            : { v: "", s: numberStyle };
        }
        if (tipo === "percent") {
          return {
            v: value === null || value === undefined ? "" : `${value}%`,
            s: percentStyle,
          };
        }
        return { v: value === null || value === undefined ? "" : value, s: cellStyle };
      };

      const formatoFechaEntrega = (fecha) =>
        fecha ? moment(fecha).format("DD/MM/YYYY") : "";

      let datosDescargar = [];
      let columnasConfig = [];

      if(this.state.desglosarProductos){
        columnasConfig = [
          { header: "Usuario", key: "Usuario", tipo: "texto" },
          { header: "Requisicion", key: "Requisicion", tipo: "texto" },
          { header: "Folio", key: "Folio", tipo: "texto" },
          { header: "Serie", key: "Serie", tipo: "texto" },
          { header: "Codigo Proveedor", key: "Codigo Proveedor", tipo: "texto" },
          { header: "Clave Proveedor", key: "Clave Proveedor", tipo: "texto" },
          { header: "Fecha", key: "Fecha", tipo: "texto" },
          { header: "Fecha Entrega", key: "Fecha Entrega", tipo: "texto" },
          { header: "Proveedor", key: "Proveedor", tipo: "texto" },
          { header: "Codigo Insumo", key: "Codigo Insumo", tipo: "texto" },
          { header: "Clave Insumo", key: "Clave Insumo", tipo: "texto" },
          { header: "Cantidad", key: "Cantidad", tipo: "numero" },
          { header: "Recibido", key: "Recibido", tipo: "numero" },
          { header: "Pendientes", key: "Pendientes", tipo: "numero" },
          { header: "Descripcion", key: "Descripcion", tipo: "texto" },
          { header: "Familia", key: "Familia", tipo: "texto" },
          { header: "Precio Unitario", key: "Precio Unitario", tipo: "money" },
          { header: "Descuento", key: "Descuento", tipo: "money" },
          { header: "% Descuento", key: "% Descuento", tipo: "percent" },
          { header: "Subtotal Insumo", key: "Subtotal Insumo", tipo: "money" },
          { header: "Precio Con Impuestos", key: "Precio Con Impuestos", tipo: "money" },
          { header: "Total Insumo", key: "Total Insumo", tipo: "money" },
          // Todas las columnas de dinero del renglon estan en la moneda de la
          // orden, sin convertir: sin estas dos, el Excel mezcla MXN y USD en
          // la misma columna. Mismo lugar que en el layout sin desglose.
          { header: "Moneda", key: "Moneda", tipo: "texto" },
          { header: "Tipo de Cambio", key: "Tipo de Cambio", tipo: "numero" },
          { header: "Estado", key: "Estado", tipo: "texto" },
          { header: "Estado Factura", key: "Estado Factura", tipo: "texto" },
          { header: "Fecha Recepcion", key: "Fecha Recepcion", tipo: "texto" },
          { header: "Fechas Recepciones", key: "Fechas Recepciones", tipo: "texto" },
          { header: "Fecha Factura", key: "Fecha Factura", tipo: "texto" },
          { header: "Fechas Facturas", key: "Fechas Facturas", tipo: "texto" },
        ];

        for (const valueCompra of this.state.todasCompras) {
          if(valueCompra.folio === ''){
            const compra = this.state.todasCompras.find(todasCompras => todasCompras.folio !== '' && todasCompras._id.toString() === valueCompra._id.toString())
            // Los dos estados se leen de la fila padre y en variables locales.
            // En la fila de insumo `estado` es el total del renglon, no el estado
            // de la orden; y reasignar compra.estadoFactura haria que la segunda
            // descarga leyera texto y cayera en "Desconocido".
            let estadoOrden = ''
            switch(compra.estado) {
              case 1:
                estadoOrden = "Sin recepciones"
                break;
              case 2:
                estadoOrden = "Con recepciones parciales"
                break;
              case 3:
                estadoOrden = "Con recepciones completas"
                break;
              default:
                estadoOrden = "Desconocido"
            }
            let estadoFacturaOrden = ''
            switch(compra.estadoFactura) {
              case 0:
                estadoFacturaOrden = "Sin factura"
                break;
              case 2:
                estadoFacturaOrden = "Con facturas parciales"
                break;
              case 3:
                estadoFacturaOrden = "Con factura completa"
                break;
              default:
                estadoFacturaOrden = "Desconocido"
            }
            datosDescargar.push({
              Usuario: compra.usuario || "",
              Requisicion: compra.requisicion || "",
              Folio: compra.folio,
              Serie: compra.serie,
              "Codigo Proveedor": compra.codigoProveedor,
              "Clave Proveedor": compra.claveProveedor,
              Fecha: compra.fechaFactura,
              "Fecha Entrega": formatoFechaEntrega(compra.fechaEntrega),
              Proveedor: compra.proveedor,
              "Codigo Insumo": valueCompra.codigoProveedor,
              "Clave Insumo": valueCompra.claveProveedor,
              Cantidad: valueCompra.fechaFactura,
              Recibido: valueCompra.recibido || 0,
              Pendientes: valueCompra.pendiente,
              Descripcion: valueCompra.proveedor,
              Familia: valueCompra.familia,
              "Precio Unitario": valueCompra.total,
              Descuento: valueCompra.descuentoMonto,
              "% Descuento": valueCompra.descuentoPorcentaje,
              "Subtotal Insumo": valueCompra.totalPagado,
              "Precio Con Impuestos": valueCompra.saldo,
              "Total Insumo": valueCompra.estado,
              // Igual que los dos estados: la moneda y el tipo de cambio son
              // de la orden, no del renglon, asi que salen de la fila padre.
              Moneda: compra.moneda,
              "Tipo de Cambio": compra.tipoCambio,
              Estado: estadoOrden,
              "Estado Factura": estadoFacturaOrden,
              // Estas cuatro salen del renglon de insumo, no de la orden:
              // son las fechas de ESE insumo.
              "Fecha Recepcion": valueCompra.fechaRecepcion || "",
              "Fechas Recepciones": valueCompra.fechasRecepciones || "",
              "Fecha Factura": valueCompra.fechaFacturaProveedor || "",
              "Fechas Facturas": valueCompra.fechasFacturasProveedor || "",
            })
          }
        }
      }else{
        columnasConfig = [
          { header: "Usuario", key: "Usuario", tipo: "texto" },
          { header: "Requisicion", key: "Requisicion", tipo: "texto" },
          { header: "Folio", key: "Folio", tipo: "texto" },
          { header: "Serie", key: "Serie", tipo: "texto" },
          { header: "Codigo Proveedor", key: "Codigo Proveedor", tipo: "texto" },
          { header: "Clave Proveedor", key: "Clave Proveedor", tipo: "texto" },
          { header: "Fecha", key: "Fecha", tipo: "texto" },
          { header: "Fecha Entrega", key: "Fecha Entrega", tipo: "texto" },
          { header: "Proveedor", key: "Proveedor", tipo: "texto" },
          { header: "Subtotal", key: "Subtotal", tipo: "money" },
          { header: "Impuestos", key: "Impuestos", tipo: "money" },
          { header: "Descuento", key: "Descuento", tipo: "money" },
          { header: "Total", key: "Total", tipo: "money" },
          { header: "Retenciones", key: "Retenciones", tipo: "money" },
          { header: "Total A Pagar", key: "Total A Pagar", tipo: "money" },
          { header: "Moneda", key: "Moneda", tipo: "texto" },
          { header: "Tipo de Cambio", key: "Tipo de Cambio", tipo: "numero" },
          { header: "Estado", key: "Estado", tipo: "texto" },
          { header: "Estado Factura", key: "Estado Factura", tipo: "texto" },
          { header: "Observaciones", key: "Observaciones", tipo: "texto" },
          { header: "Observaciones Internas", key: "Observaciones Internas", tipo: "texto" },
          { header: "Fecha Recepcion", key: "Fecha Recepcion", tipo: "texto" },
          { header: "Fechas Recepciones", key: "Fechas Recepciones", tipo: "texto" },
          { header: "Fecha Factura", key: "Fecha Factura", tipo: "texto" },
          { header: "Fechas Facturas", key: "Fechas Facturas", tipo: "texto" },
        ];

        datosDescargar = this.state.todasCompras.map((valueCompra) => {
          let estadoOrden = ''
          switch(valueCompra.estado) {
            case 1:
              estadoOrden = "Sin recepciones"
              break;
            case 2:
              estadoOrden = "Con recepciones parciales"
              break;
            case 3:
              estadoOrden = "Con recepciones completas"
              break;
            default:
              estadoOrden = "Desconocido"
          }
          // En una variable local, no reasignando el campo: si se mutara el
          // objeto del state, la segunda descarga leeria texto y caeria en
          // "Desconocido".
          let estadoFacturaOrden = ''
          switch(valueCompra.estadoFactura) {
            case 0:
              estadoFacturaOrden = "Sin factura"
              break;
            case 2:
              estadoFacturaOrden = "Con facturas parciales"
              break;
            case 3:
              estadoFacturaOrden = "Con factura completa"
              break;
            default:
              estadoFacturaOrden = "Desconocido"
          }
          return {
            Usuario: valueCompra.usuario || "",
            Requisicion: valueCompra.requisicion || "",
            Folio: valueCompra.folio,
            Serie: valueCompra.serie,
            "Codigo Proveedor": valueCompra.codigoProveedor,
            "Clave Proveedor": valueCompra.claveProveedor,
            Fecha: valueCompra.fechaFactura,
            "Fecha Entrega": formatoFechaEntrega(valueCompra.fechaEntrega),
            Proveedor: valueCompra.proveedor,
            Subtotal: valueCompra.subtotal,
            Impuestos: valueCompra.impuestos,
            Descuento: valueCompra.descuento,
            Total: valueCompra.total,
            Retenciones: valueCompra.retenciones,
            "Total A Pagar": valueCompra.totalPagar,
            Moneda: valueCompra.moneda,
            "Tipo de Cambio": valueCompra.tipoCambio,
            Estado: estadoOrden,
            "Estado Factura": estadoFacturaOrden,
            Observaciones: valueCompra.observaciones || "",
            "Observaciones Internas": valueCompra.observacionesInternas || "",
            "Fecha Recepcion": valueCompra.fechaRecepcion || "",
            "Fechas Recepciones": valueCompra.fechasRecepciones || "",
            "Fecha Factura": valueCompra.fechaFacturaProveedor || "",
            "Fechas Facturas": valueCompra.fechasFacturasProveedor || "",
          };
        });
      }

      const rows = [
        columnasConfig.map((columna) => ({ v: columna.header, s: headerStyle })),
        ...datosDescargar.map((fila) =>
          columnasConfig.map((columna) => celda(fila[columna.key], columna.tipo))
        ),
      ];

      const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = columnasConfig.map((columna) => ({
        // Las columnas "Fechas ..." concatenan varias fechas en una celda: el
        // ancho del encabezado se queda corto.
        wch:
          ANCHOS_ESPECIALES[columna.key] ||
          (columna.key.startsWith("Fechas ")
            ? 34
            : Math.max(columna.header.length + 2, 12)),
      }));
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Reporte Ordenes de Compras");
      XLSXStyle.writeFile(workbook, "Reporte_OrdenesCompras.xlsx");
    }
  
    descargarPdf() {
      pdfMake
        .createPdf(reporteDeOrdenesDeCompraPdf(this.state.dataReporte))
        .download("Reporte Ordenes de Compras");
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
    render() {
      const esValorVacio = (v) =>
        v === undefined ||
        v === null ||
        v === "" ||
        (typeof v === "number" && isNaN(v));
      const columns = [
        {
          title: "Folio",
          key: "folio",
          sorter: (a, b) => {
            if (a.folio < b.folio) return -1;
            if (a.folio > b.folio) return 1;
            return 0;
          },
          buscar: "folio",
          ellipsis: true,
          render: (_, record) => {
            if (esValorVacio(record.folio)) return "";
            const serie = esValorVacio(record.serie) ? "" : record.serie;
            return serie ? `${record.folio} - ${serie}` : `${record.folio}`;
          },
        },        
        {
          title: "Fecha",
          dataIndex: "fechaFactura",
          key: "fechaFactura",
          sorter: (a, b) => {
            if (moment(a.fechaFactura, "DD/MM/YYYY") < moment(b.fechaFactura, "DD/MM/YYYY")) {
              return -1;
            }
            if (moment(a.fechaFactura, "DD/MM/YYYY") > moment(b.fechaFactura, "DD/MM/YYYY")) {
              return 1;
            }
            return 0;
          },
          buscar: "fechaFactura",
          ellipsis: true,
        },
        {
          title: "Proveedor",
          dataIndex: "proveedor",
          key: "proveedor",
          sorter: (a, b) => {
            if (a.proveedor < b.proveedor) {
              return -1;
            }
            if (a.proveedor > b.proveedor) {
              return 1;
            }
            return 0;
          },
          buscar: "proveedor",
          ellipsis: true,
        },
        {
          title: "Subtotal",
          dataIndex: "subtotal",
          key: "subtotal",
          sorter: (a, b) => {
            if (a.subtotal < b.subtotal) {
              return -1;
            }
            if (a.subtotal > b.subtotal) {
              return 1;
            }
            return 0;
          },
          buscar: "subtotal",
          ellipsis: true,
          render: (value) => (esValorVacio(value) ? "" : dineroDisabledMask(value)),
          align: "right",
        },
        {
          title: "Precio Unitario",
          dataIndex: "total",
          key: "precioUnitario",
          ellipsis: true,
          render: (value, record) => (esValorVacio(record.folio) ? dineroDisabledMask(value) : ""),
          align: "right",
        },
        {
          title: "Descuento",
          dataIndex: "descuentoMonto",
          key: "descuentoMonto",
          ellipsis: true,
          render: (value, record) => (esValorVacio(record.folio) ? dineroDisabledMask(value) : ""),
          align: "right",
        },
        {
          title: "% Descuento",
          dataIndex: "descuentoPorcentaje",
          key: "descuentoPorcentaje",
          ellipsis: true,
          render: (value, record) => (esValorVacio(record.folio) ? `${value}%` : ""),
          align: "right",
        },
        {
          title: "Total",
          dataIndex: "total",
          key: "total",
          sorter: (a, b) => {
            if (a.total < b.total) {
              return -1;
            }
            if (a.total > b.total) {
              return 1;
            }
            return 0;
          },
          buscar: "total",
          render: (value, record) => (esValorVacio(record.folio) ? "" : dineroDisabledMask(value)),
          align: "right",
          ellipsis: true,
        },
        {
          title: "Estado",
          dataIndex: "estado",
          key: "estado",
          sorter: (a, b) => a.estado - b.estado,
          buscar: "estado",
          ellipsis: true,
          render: (estado) => {
            switch (estado) {
              case 1:
                return "Sin recepciones";
              case 2:
                return "Con recepciones parciales";
              case 3:
                return "Con recepciones completas";
              default:
                return "Desconocido";
            }
          },
        },
        {
          title: "Observaciones",
          dataIndex: "observaciones",
          key: "observaciones",
          ellipsis: true,
        },
        {
          title: "Observaciones Internas",
          dataIndex: "observacionesInternas",
          key: "observacionesInternas",
          ellipsis: true,
        },
        // Estas cuatro son las unicas columnas que significan lo mismo en la
        // fila de la orden y en la del insumo: el backend ya resolvio el nivel
        // correcto, por eso no llevan el gating de esValorVacio(record.folio).
        {
          title: "Fecha Recepcion",
          dataIndex: "fechaRecepcion",
          key: "fechaRecepcion",
          width: 110,
          ellipsis: true,
        },
        {
          title: "Fechas Recepciones",
          dataIndex: "fechasRecepciones",
          key: "fechasRecepciones",
          width: 150,
          ellipsis: true,
        },
        {
          title: "Fecha Factura",
          dataIndex: "fechaFacturaProveedor",
          key: "fechaFacturaProveedor",
          width: 110,
          ellipsis: true,
        },
        {
          title: "Fechas Facturas",
          dataIndex: "fechasFacturasProveedor",
          key: "fechasFacturasProveedor",
          width: 150,
          ellipsis: true,
        },
      ];
      return (
        <>
          <Form
            ref={this.formRef}
            name="rerpoteOrdenesDeCompras"
            onFinish={this.consultarReporteCompras.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Ordenes de Compras"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                  <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                    <FormItem name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                    <FormItem name="proveedores" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Proveedores"
                      >
                        {this.state.objetoProveedores}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" margin noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required margin name="unidadDeNegocioId" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                    <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                      <Col span={8}>
                        <FormItem
                          label="Estado Factura"
                          name="estadoFactura"
                          required
                          initialValue={5}
                          style={{ marginBottom: 0 }}
                        >
                          <SelectItem placeholder="Filtrar Por">
                            <Option default value={5}>
                              Todos
                            </Option>
                            <Option value={0}>Sin factura</Option>
                            <Option value={2}>Con facturas parciales</Option>
                            <Option value={3}>Con facturas completas</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          label="Estado"
                          name="estado"
                          required
                          initialValue={5}
                          style={{ marginBottom: 0 }}
                        >
                          <SelectItem placeholder="Filtrar Por">
                            <Option default value={5}>
                              Todos
                            </Option>
                            <Option value={0}>Sin recepcion</Option>
                            <Option value={2}>Con recepciones parciales</Option>
                            <Option value={3}>Con recepciones completas</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          label="Desglosar Productos"
                          name="desglosarProductos"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem>
                      </Col>
                      {/* <Col span={8}>
                         <FormItem
                          label="Detalle"
                          name="detalle"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem> 
                      </Col> */}
                    </Row>
                  </TabPane> 
                </Tabs>
              </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                enableSlices="x"
                useMesh={true}

                yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}

                curve="monotoneX"
                lineWidth={2}

                // ✅ Menos ruido visual
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}

                // Si quieres aún más limpio, descomenta:
                // enablePoints={false}

                colors={["#ff6633", "#FF926E"]}
                colorBy="index"

                axisTop={null}
                axisRight={null}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  // ✅ muestra menos etiquetas (una de cada 2 o 3)
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}

                // ✅ Grid más limpio
                enableGridX={false}

                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
                <Row>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Subtotal</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.subtotal)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>+</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Impuestos</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalImpuestos)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>=</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Total</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.total)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>-</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Retenciones</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalRetenciones)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>=</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Total A Pagar</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalAPagar)}
                    </h1>
                  </Col>
                </Row>
              </div>
              <TableItem
                // onRow={(record, rowIndex) => {
                //   return {
                //     onDoubleClick: (event) => {
                //       this.props.history.push("/panel/verVenta", {
                //         id: record._id,
                //       });
                //     },
                //   };
                // }}
                rowKey={(value) => value._id.toString() + Math.random()}
                columns={columns}
                dataSource={this.state.todasCompras}
                size="small"
                pagination={false}
              />
              {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
            </Spin>
          </Form>
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(ReporteOrdenesDeCompras);
  